export enum NCZI_OID {
	SPECIALIZATION = '1.3.158.00165387.100.10.34',
	CITY = '1.3.158.00165387.100.10.45',
	POST_CODE = '1.3.158.00165387.100.10.150',
	REGION = '1.3.158.00165387.100.10.43',
	COUNTRY = '1.3.158.00165387.100.10.51',
	RELATIONSHIP = '1.3.158.00165387.100.10.54',
	HEALTH_PROFESSIONAL = '1.3.158.00165387.100.40.90',
	HEALTH_SERVICE_PROVIDER_OUPZS = '1.3.158.00165387.100.40.70',
	HEALTH_SERVICE_PROVIDER = '1.3.158.00165387.100.40.80',
	MEDICAL_DEVICE = '1.3.158.00165387.100.40.10',
	DIETETIC_FOOD = '1.3.158.00165387.100.40.30',
	MEDICAMENTS = '1.3.158.00165387.100.40.50',
	UNIT = '1.3.158.00165387.100.10.87',
	VACCINATION_KIND = '1.3.158.00165387.100.10.35',
	VACCINATION_TYPE = '1.3.158.00165387.100.10.36',
	VACCINATION_REACTION_TYPE = '1.3.158.00165387.100.10.58',
	ATC_CLASSIFICATION_SYSTEM = '1.3.158.00165387.100.10.83',
	ALLERGENS = '1.3.158.00165387.100.10.158',
	ADVERSE_REACTION_SYMPTOMS = '1.3.158.00165387.100.10.159',
	DIAGNOSIS = '1.3.158.00165387.100.10.25',
	DPN_REASON = '1.3.158.00165387.100.10.265',
	OPERATION = '1.3.158.00165387.100.10.26',
	MEDICAL_DEVICE_UNIT = '1.3.158.00165387.100.10.211',
	DOSAGE_TYPE = '1.3.158.06230458.1.1.1',
	DOSAGE_PERIODICITY = '1.3.158.06230458.1.1.2',
	DOSAGE_METHOD_ADMINISTRATION = '1.3.158.06230458.1.1.3',
	DOSAGE_UNIT = '1.3.158.06230458.1.1.4',
	STOCK_DOSAGE_FORM = '1.3.158.06230458.1.1.5',
	DOSAGE_RELATION_UNIT = '1.3.158.06230458.1.1.6',
	IPL_CODES = '1.3.158.06230458.1.1.7',
	IMPLANTED_MEDICAL_DEVICES = '1.3.158.00165387.100.10.126',
	INDICATION_LIMITATION = '1.3.158.06230458.1.1.8',
	EXAMINATION_URGENCY = '1.3.158.00165387.100.10.123',
	RECOMMENDATION_FOR_EXAMINATION = '1.3.158.00165387.100.10.37',
	PROFESSIONAL_FOCUS = '1.3.158.00165387.100.10.39',
	EXAMINED_BODY_PART = '1.3.158.00165387.100.10.115',
	MODALITY_OF_IMAGING_EXAMINATION = '1.3.158.00165387.100.10.256',
}
